function getSettings(userSettings) {
  const notificationSettings = userSettings.find(
    setting => setting.type === "notifications"
  );

  const notificationStatus = notificationSettings
    ? notificationSettings.value
    : false;
    

  const suspendSettings = userSettings.find(
    setting => setting.type === "suspend"
  );

  return {
    notifications: notificationStatus,
    suspend: suspendSettings.value
  };
}

export default getSettings;
